export function getVehicleTourSteps(isMobile = false) {
  if (isMobile) {
    return [
      {
        target: '[data-testid="vehicle-gallery"]',
        title: "תמונות וסרטון הרכב",
        content: "עיינו בכל התמונות לפני שמגישים הצעה. ספקים מעלים תמונות מכל כיוון - כולל נזקים.",
        placement: "bottom",
      },
      {
        target: '[data-testid="vehicle-details-accordion"]',
        title: "פרטי הרכב",
        content: "כאן תראו פרטים טכניים, ואת מפרט הרכב. מומלץ לעבור על הכל לפני שליחת הצעה.",
        placement: "top",
      },
      {
        target: '[data-testid="vehicle-mobile-offer-cta"]',
        title: "שלחו הצעת מחיר",
        content: 'מכאן פותחים במובייל את טופס ההצעה. לחצו כדי להזין מחיר, תאריכים ופרטי תשלום.',
        placement: "top",
      },
    ];
  }

  return [
    {
      target: '[data-testid="vehicle-gallery"]',
      title: "תמונות וסרטון הרכב",
      content: "עיינו בכל התמונות לפני שמגישים הצעה. ספקים מעלים תמונות מכל כיוון - כולל נזקים.",
      placement: "left",
    },
    {
      target: '[data-testid="vehicle-details-accordion"]',
      title: "פרטי הרכב",
      content: "כאן תראו פרטים טכניים, ואת מפרט הרכב. מומלץ לעבור על הכל לפני שליחת הצעה.",
      placement: "top",
    },
    {
      target: '[data-testid="min-price-display"]',
      title: "מחיר מומלץ",
      content: "ניתן להגיש הצעה החל מ-15% מתחת למחיר המומלץ ומעלה.",
      placement: "bottom",
    },
    {
      target: '[data-testid="offer-amount-input"]',
      title: "כתבו את ההצעה שלכם",
      content: "הזינו את הסכום שאתם מוכנים לשלם. **זוהי הצעה בלבד** - הספק יחליט אם לאשר. תוכלו לשפר את ההצעה מאוחר יותר.",
      placement: "right",
    },
    {
      target: '[data-testid="reservation-toggle"]',
      title: "שריון הרכב (אופציונלי)",
      content: "הפעילו אם אתם מעוניינים לשריין את הרכב יחד עם ההצעה. **שימו לב** - השריון כרוך בתנאים נוספים.",
      placement: "top",
    },
    {
      target: '[data-testid="submit-offer-btn"]',
      title: "שלחו את ההצעה",
      content: 'לאחר שמילאתם את הסכום - **לחצו כאן**. ההצעה תישלח לספק ותוכלו לעקוב אחריה בעמוד **"הצעות שלי"**.',
      placement: "left",
    },
  ];
}

const vehicleTourSteps = getVehicleTourSteps(false);

export default vehicleTourSteps;
